import { useState } from 'react';
import type { TripView } from '@voll-intelligence/domain';
import { TripItinerary } from '@voll-intelligence/trip-panel';
import '@voll-intelligence/trip-panel/styles.css';

import { t } from '@web/i18n';
import { TripVoucherDocument, tripServiceOf } from '@web/ui/core/molecules';
import { twcn } from '@web/ui/core/utils';

import { Drawer } from '../drawer';

/**
 * The read-only itinerary of a trip plus the drawer a step opens its voucher in
 * (the operator reads, never composes or archives). The screen keeps its own
 * header and frame; `className` sizes the itinerary's `.genui2` root.
 */
export function TripItineraryWithVoucher({
  trip,
  className,
}: Readonly<{ trip: TripView; className?: string }>): React.JSX.Element {
  const [voucherKey, setVoucherKey] = useState<string | null>(null);
  const service = tripServiceOf(trip, voucherKey);
  const closeVoucher = () => {
    setVoucherKey(null);
  };
  return (
    <>
      {/* `.genui2` root: the package's `tp-*`/`vj-badge` classes and the design-system
          utilities the itinerary uses (`text-detail`, `rounded-xl`…) only exist under it. */}
      <div className={twcn('genui2', className)}>
        <TripItinerary
          trip={trip}
          authenticated={false}
          onOpenVoucher={(key) => {
            setVoucherKey(key);
          }}
        />
      </div>
      <Drawer
        open={service !== undefined}
        onClose={closeVoucher}
        ariaLabel={t('card.trip.voucherAria')}
      >
        {service ? <TripVoucherDocument service={service} onClose={closeVoucher} /> : null}
      </Drawer>
    </>
  );
}
